import { useMemo, useCallback } from 'react';
import { ActivityIndicator, View } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { SafeAreaView } from 'react-native-safe-area-context';
import { MatchHub } from '../../../../components/match/MatchHub';
import { useMatchHubData } from '../../../../src/match/hooks/useMatchHubData';
import { useTheme } from '../../../../src/theme/useTheme';
import { getMatchHubStyles } from '../../../../components/match/MatchHub/MatchHub.styles';

export default function WorldCupMatchHubRoute() {
  const router = useRouter();
  const theme = useTheme();
  const layoutStyles = useMemo(() => getMatchHubStyles(theme), [theme]);
  const { gameId } = useLocalSearchParams<{ gameId: string }>();
  const id = typeof gameId === 'string' ? gameId : '';
  const { data, isLoading } = useMatchHubData(id);

  const handleBack = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <SafeAreaView style={[layoutStyles.flex, layoutStyles.bodyBg]} edges={['top', 'left', 'right']}>
      {isLoading || data === null ? (
        <View style={layoutStyles.flex}>
          <ActivityIndicator style={layoutStyles.flex} color={theme.primary} />
        </View>
      ) : (
        <MatchHub data={data} onBack={handleBack} />
      )}
    </SafeAreaView>
  );
}
